import React, { useState, useEffect, useMemo } from 'react';
import { AutoComplete, Form, Input, Spin } from 'antd';
import { useLazyQuery } from '@apollo/client';
import { debounce } from 'lodash';
import { SEARCH_AICS_MUNICIPALITIES } from '../../../../../apollo/query/aics';

const AicsMunicipalityInput = ({ value, onChange, provinceFieldName = 'birth_province' }) => {
    const form = Form.useFormInstance();
    const [searchText, setSearchText] = useState(value || '');

    useEffect(() => {
        setSearchText(value || '');
    }, [value]);

    const [search, { data, loading }] = useLazyQuery(SEARCH_AICS_MUNICIPALITIES, {
        fetchPolicy: 'network-only',
    });

    const debouncedSearch = useMemo(
        () =>
            debounce((query) => {
                if (query && query.trim().length >= 2) {
                    search({ variables: { query: query.trim(), province: null } });
                }
            }, 300),
        [search],
    );

    useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

    const options = (data?.searchAicsMunicipalities || []).map((m) => ({
        value: m.name,
        label: `${m.name} (${m.province})`,
        province: m.province,
    }));

    const handleSearch = (text) => {
        setSearchText(text);
        debouncedSearch(text);
    };

    const handleChange = (text) => {
        const upper = (text || '').toUpperCase();
        setSearchText(upper);
        onChange?.(upper);
    };

    const handleSelect = (selectedValue, option) => {
        const upper = (selectedValue || '').toUpperCase();
        setSearchText(upper);
        onChange?.(upper);
        if (option?.province) {
            form.setFieldsValue({ [provinceFieldName]: option.province.toUpperCase() });
        }
    };

    const province = Form.useWatch(provinceFieldName, form);

    return (
        <Input.Group compact style={{ display: 'flex' }}>
            <AutoComplete
                style={{ flex: 1 }}
                value={searchText}
                options={options}
                onSearch={handleSearch}
                onSelect={handleSelect}
                onChange={handleChange}
                notFoundContent={loading ? <Spin size="small" /> : null}
            />
            <Input
                style={{ width: 70, textAlign: 'center', backgroundColor: '#fafafa' }}
                value={province || ''}
                disabled
                placeholder="—"
            />
        </Input.Group>
    );
};

export default AicsMunicipalityInput;
